var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{staticClass:"header",attrs:{"path":_vm.path}}),_c('router-view',{class:{ 'body-top': _vm.path !== '/' && _vm.path !== '/recruit-new' && _vm.path !== '/recruit-deshi' }}),_c('ToTopButton',{attrs:{"path":_vm.path}}),_c('Footer',{class:{
      ctrl:
        _vm.path === '/ctrl' || _vm.path === '/ctrl/login' || _vm.path === '/ctrl/info',
    },attrs:{"path":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }